export default function trackSearch(fromPath: string, reference?: string) {
  if (typeof window === "undefined" || typeof window.gtag !== "function")
    return;

  window.gtag("event", "search", {
    search_origin: fromPath.split("?")[0],
    search_reference: reference,
  });
}
